import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import Spinner from "src/components/Spinner/Spinner";
import { IAdminFair } from "src/Types/module/fair/adminFair";
import CommCard from "src/common/CommCard";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import FairTableRow from "./FairTableRow";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import CreateFair from "./CreateFair";
import { CommonPagination } from "src/common/CommonPagination";

const AdminFair = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [searchParams, setSearchParams] = useState({ status: "" });
	const { data: fairs, isLoading } = useGetQueryWithTotal<IAdminFair[]>({
		endPoint: `/api/fair`,
		queryKeys: ["Fairs", searchParams.status],
		params: { status: searchParams.status, ...pagination },
	});
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<CommCard
			headerTitle={`Fair List (${fairs?.total || 0})`}
			helmetTitle='BTTF - Fair list'
			showCardHeader
			showButton
			btnText='Create Fair'
			handleBtnForModalFun={() => handleOpen()}
			statusOptions={[
				{
					id: "all",
					name: "All",
				},
				{
					id: "upcoming",
					name: "Upcoming",
				},
				{
					id: "ended",
					name: "Ended",
				},
				{
					id: "cancelled",
					name: "Cancelled",
				},
			]}
			handleSelectStatus={(status) =>
				setSearchParams((prev) => ({ ...prev, status }))
			}
			showStatus
		>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Fair name</TableCell>
							<TableCell>Venue Layout</TableCell>
							<TableCell>Fair status</TableCell>
							<TableCell>Fair start date</TableCell>
							<TableCell>Fair end date</TableCell>
							<TableCell>Fair location</TableCell>
							<TableCell>Action</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : fairs?.data?.length ? (
						<TableBody>
							{fairs?.data?.map((fair, idx) => {
								return (
									<FairTableRow
										key={fair.fair_id}
										fair={fair}
										serial={idx + 1}
									/>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
				<Box p={2}>
					<CommonPagination
						total={fairs?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</TableContainer>

			<ModalsWrapper
				setShowModal={setOpen}
				modalData={{ title: "Create New Fair" }}
				showModal={open}
			>
				<CreateFair handleClose={() => handleClose()} />
			</ModalsWrapper>
		</CommCard>
	);
};

export default AdminFair;
